import I18n from './i18n'

function install (Vue) {
  const i18n = I18n.getInstance()

  Vue.t = function (key, options) {
    return i18n.translate(key, options)
  }

  Vue.prototype.$t = function (key, options) {
    const defualts = this.$options.ns ? { ns: this.$options.ns } : {}
    return i18n.translate(key, options, defualts)
  }

  Vue.prototype.$translateHtml = function (key) {
    return i18n.translateHtml(key)
  }
}

export default {
  install
}



// WEBPACK FOOTER //
// ./src/services/i18n/index.js